module.exports = "../../app/cells/pages/question/search_cell.rb";